import React, { useState } from "react";
import {
  Box,
  Paper,
  Typography,
  Button,
  Container,
  useTheme,
  useMediaQuery,
  Card,
  CardContent,
} from "@mui/material";
import AddCompanyForNewUser from "../pages/AddCompanyForNewUser";
import { Logout as LogoutIcon } from "@mui/icons-material";
import { useAuth } from "../auth/AuthContext";
import { useNavigate } from "react-router-dom";
const NotAddedByAdmin = ({ email }) => {
  const navigate = useNavigate();

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const { logout, currentUser } = useAuth();
  const [logoutPopOpen, setLogoutPopOpen] = useState(false);

  const handleContactAdmin = () => {
    const adminEmail = "waghvaishnavi1122@gmail.com";
    const subject = `Access Request - ${email} to LeadsTosell CRM  Portal`;
    const body = `Hello Admin,\n\nI would like to request access to the system.\n\nMy email: ${email}\n\nPlease grant me access to the application.\n\nThank you.`;

    // Open Gmail with pre-filled email, subject, and body
    const gmailUrl = `https://mail.google.com/mail/?view=cm&fs=1&to=${adminEmail}&su=${encodeURIComponent(
      subject
    )}&body=${encodeURIComponent(body)}`;
    window.open(gmailUrl, "_blank");
  };

  const handleLogout = async () => {
    try {
      await logout();
      navigate("/login");
    } catch (error) {
      console.error("Logout failed", error);
    }
  };

  return (
    <Container maxWidth="md">
      <Box
        sx={{
          minHeight: "100vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          bgcolor: "grey.50",
          mt: -13,
          ml: -8,
        }}
      >
        <Box sx={{ width: "100%", maxWidth: 800 }}>
          {/* Header */}
          <Box sx={{ textAlign: "center", mb: 4 }}>
            <Typography
              variant={isMobile ? "h5" : "h4"}
              component="h1"
              color="error.main"
              fontWeight="bold"
              gutterBottom
            >
              Access Required
            </Typography>
            <Typography variant="h6" color="text.secondary" sx={{ mb: 2 }}>
              Email not registered in the system
            </Typography>
            <Typography
              variant="body1"
              color="text.secondary"
              sx={{ fontStyle: "italic" }}
            >
              ({email})
            </Typography>
            <Button
              variant="contained"
              color="error"
              onClick={handleLogout}
              sx={{ textTransform: "none" }}
            >
              Logout
            </Button>
          </Box>

          {/* Two Column Layout with OR separator */}
          <Box sx={{ position: "relative" }}>
            <Box
              sx={{
                display: "grid",
                gridTemplateColumns: { xs: "1fr", md: "1fr 1fr" },
                gap: 10,
                alignItems: "start",
              }}
            >
              {/* Contact Admin Card */}
              <Card
                elevation={4}
                sx={{
                  border: 2,
                  borderColor: "error.main",
                  bgcolor: "error.light",
                  background: `linear-gradient(135deg, ${theme.palette.error.light}15 0%, ${theme.palette.background.paper} 100%)`,
                  borderRadius: 3,
                  height: "100%",
                }}
              >
                <CardContent sx={{ p: 4, textAlign: "center" }}>
                  <Typography
                    variant="h6"
                    color="error.main"
                    fontWeight="bold"
                    gutterBottom
                  >
                    Contact Administrator
                  </Typography>

                  <Typography
                    variant="body2"
                    color="text.secondary"
                    sx={{ mb: 3 }}
                  >
                    Request access from the system administrator
                  </Typography>

                  {/* <Typography
                    variant="body1"
                    color="primary.main"
                    fontWeight="medium"
                    sx={{ mb: 3 }}
                  >
                    waghvaishnavi1122@gmail.com
                  </Typography> */}

                  <Button
                    variant="contained"
                    size="large"
                    onClick={handleContactAdmin}
                    sx={{
                      bgcolor: "error.main",
                      color: "white",
                      fontWeight: 500,
                      px: 4,
                      py: 1.5,
                      borderRadius: 2,
                      fontSize: "1rem",
                      textTransform: "none",
                      boxShadow: 3,
                      "&:hover": {
                        bgcolor: "error.dark",
                        boxShadow: 6,
                        transform: "translateY(-2px)",
                      },
                      transition: "all 0.2s ease-in-out",
                    }}
                  >
                    Send Email Request
                  </Button>
                </CardContent>
              </Card>

              {/* Add Company Card */}
              <Card
                elevation={4}
                sx={{
                  border: 2,
                  borderColor: "success.main",
                  bgcolor: "success.light",
                  background: `linear-gradient(135deg, ${theme.palette.success.light}15 0%, ${theme.palette.background.paper} 100%)`,
                  borderRadius: 3,
                  height: "100%",
                }}
              >
                <CardContent sx={{ p: 4, textAlign: "center" }}>
                  <Typography
                    variant="h6"
                    color="success.main"
                    fontWeight="bold"
                    gutterBottom
                  >
                    Register Your Company
                  </Typography>

                  <Typography
                    variant="body2"
                    color="text.secondary"
                    sx={{ mb: 3 }}
                  >
                    Submit your company for approval
                  </Typography>

                  <AddCompanyForNewUser email={email} />
                </CardContent>
              </Card>
            </Box>

            {/* OR Separator */}
            <Box
              sx={{
                position: "absolute",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                display: { xs: "none", md: "flex" },
                alignItems: "center",
                justifyContent: "center",
                zIndex: 1,
              }}
            >
              <Box
                sx={{
                  bgcolor: "background.paper",
                  border: 2,
                  borderColor: "grey.300",
                  borderRadius: "50%",
                  width: 60,
                  height: 60,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  boxShadow: 2,
                }}
              >
                <Typography
                  variant="h6"
                  color="text.secondary"
                  fontWeight="bold"
                >
                  OR
                </Typography>
              </Box>
            </Box>

            {/* Mobile OR Separator */}
            <Box
              sx={{
                display: { xs: "flex", md: "none" },
                alignItems: "center",
                justifyContent: "center",
                my: 3,
              }}
            >
              <Box sx={{ flex: 1, height: 2, bgcolor: "grey.300" }} />
              <Typography
                variant="h6"
                color="text.secondary"
                fontWeight="bold"
                sx={{ mx: 2 }}
              >
                OR
              </Typography>
              <Box sx={{ flex: 1, height: 2, bgcolor: "grey.300" }} />
            </Box>
          </Box>
        </Box>
      </Box>
    </Container>
  );
};

export default NotAddedByAdmin;
